import { Component, Input, OnChanges } from "@angular/core";
import { Zone, ZoneMetadata } from "@common/ADAPT.Common.Model/methodology/zone";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";

@Component({
    selector: "adapt-zone-label",
    templateUrl: "./zone-label.component.html",
    styleUrl: "./zone-label.component.css",
    standalone: false,
})
export class ZoneLabelComponent implements OnChanges {
    @Input() public zone: Zone | undefined;
    @Input() public applyZoneColor = true;

    public zoneIcon = "";
    public zoneText = "";
    public zoneColour = "";

    public constructor(
        private orgService: OrganisationService,
    ) { }

    public ngOnChanges(): void {
        if (this.zone) {
            this.zoneText = ZoneMetadata.Name[this.zone];
            if (this.zone === Zone.ResearchAndDevelopment) {
                this.orgService.getOrganisationConfiguration().subscribe((config) => this.zoneText = config.productZoneName);
            }

            this.zoneIcon = ZoneMetadata.Icon[this.zone];
            this.zoneColour = ZoneMetadata.Colour[this.zone];
        }
    }
}
